import React, { useEffect, useRef, useState } from 'react';
import { Platform, View } from 'react-native';

import { SPINE_ASSETS } from '../../../assets/spine';
import SpineAnimation from '../../../components/SpineAnimation';
import { useDevice } from '../../../utils/hooks/useDevice';

const DEFAULT_SCALE = Platform.select({ web: 1.0, default: 1.8 }) ?? 1.8;

const AnimatedLogo = ({ scale = DEFAULT_SCALE }: { scale?: number }) => {
	const { skeletonFile, atlasFile, animations } = SPINE_ASSETS.logo;
	const { isWeb } = useDevice();

	const [animState, setAnimState] = useState({
		name: isWeb ? animations.idle : animations.enter,
		loop: isWeb,
	});

	const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	const width = 285 * scale;
	const height = 340 * scale;

	useEffect(() => {
		if (isWeb) return;

		timerRef.current = setTimeout(() => {
			setAnimState({ name: animations.idle, loop: true });
		}, 1333);

		return () => {
			if (timerRef.current) clearTimeout(timerRef.current);
		};
	}, [animations.idle, isWeb]);

	return (
		<View style={{ width, height, overflow: 'visible' }}>
			<SpineAnimation
				skeletonFile={skeletonFile}
				atlasFile={atlasFile}
				animationName={animState.name}
				loop={animState.loop}
				playing
				width={width}
				height={height}
			/>
		</View>
	);
};

export default AnimatedLogo;
